module.exports = __webpack_public_path__ + "img/10.130cf956.jpg";